import { z } from 'zod';

/**
 * @openapi
 * components:
 *   schemas:
 *     CreateAppDto:
 *       type: object
 *       properties:
 *         name:
 *           type: string
 *           description: The name of the application
 *         orgId:
 *           type: string
 *           description: The ID of the organization this app belongs to
 *       required:
 *         - name
 *         - orgId
 */
export const createAppDto = z.object({
  name: z.string().min(1),
  domain: z.string().min(1),
});

export type CreateAppDto = z.infer<typeof createAppDto>;
